export default ($) => {
	libraryJournals();

	function libraryJournals() {
		let journalsForm = document.getElementById('journals-search');

		if(typeof journalsForm !== 'undefined' && journalsForm !== null) {
			let searchType = journalsForm.elements['search-type'];
			let journalsSubmitBtn = document.getElementsByClassName('journals-search-btn')[0];

			journalsForm.addEventListener('submit', function(e){
				e.preventDefault();
				doSearchjournals();
			});

			journalsSubmitBtn.addEventListener('click', function(e){
				e.preventDefault();
				doSearchjournals();
			});

			journalsSubmitBtn.addEventListener('keydown', function(e){
				e.preventDefault();
				if (e.keyCode === 13) {
					doSearchjournals();
				}
			});

			searchType.addEventListener('change', function(e){
				doToggleFields();
			});
		}
	}

	function doSearchjournals() {
		let journalsForm = document.getElementById('journals-search');
		let journalsURL = journalsForm.getAttribute('action') + '?';
		let searchType = journalsForm.elements['search-type'].value;
		let vVal = journalsForm.elements['V'].value;
		let nVal = journalsForm.elements['N'].value;
		let lVal = journalsForm.elements['L'].value;
		let sVal;
		let cVal;
		switch (searchType){
			case 'By Subject':
				sVal = journalsForm.elements['S'].value;
				cVal = journalsForm.elements['search-subject'].value;
				break;
			case 'By Title':
				sVal = journalsForm.elements['search-param'].value;
				cVal = journalsForm.elements['journals-search-field'].value;
				journalsURL += 'N=' + nVal + '&';
				break;
		}
		journalsURL += 'V=' + vVal + '&L=' + lVal + '&S=' + sVal + '&C=' + cVal;
		window.open(journalsURL,'_blank');
	}

	function doToggleFields() {
		let journalsForm = document.getElementById('journals-search');
		let searchType = journalsForm.elements['search-type'].value;
		let subjFields = document.getElementsByClassName('journals-search-subject');
		let titleFields = document.getElementsByClassName('journals-search-title');
		switch (searchType){
			case 'By Subject':
				for(let sf=0; sf<subjFields.length; sf++) {
					subjFields[sf].classList.remove('hidden');
				}
				for(let tf=0; tf<titleFields.length; tf++) {
					titleFields[tf].classList.add('hidden');
				}
				break;
			case 'By Title':
				for(let sf=0; sf<subjFields.length; sf++) {
					subjFields[sf].classList.add('hidden');
				}
				for(let tf=0; tf<titleFields.length; tf++) {
					titleFields[tf].classList.remove('hidden');
				}
				break;
		}
	}
}